import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import { setNarrative } from '../actions/narrative'
import { connect } from 'react-redux'
import { setModal } from '../actions/appSettings'
import { Comment } from './Comment'

class Comments extends Component {
  MAX_COMMENT_LENGTH = 1000
  state = { textAreaHeight: 80, displayOldComments: false }
  textAreaRef = React.createRef()

  onCommentChange = event => {
    const new_comment = event.target.value
    if (new_comment.length > this.MAX_COMMENT_LENGTH) {
      this.props.setModal(`You cannot enter more than ${this.MAX_COMMENT_LENGTH} characters for your comment.`)
      return false
    } else {
      this.props.setNarrative({
        ...this.props.narrative,
        [this.props.currentTab + '_comment']: new_comment,
      })
      Comments.expandTextAreaToContents(event.target)
    }
  }

  componentDidMount() {
    Comments.expandTextAreaToContents(this.textAreaRef.current)
  }

  static expandTextAreaToContents = control => {
    control.style.height = ''
    control.style.height = control.scrollHeight + 10 + 'px'
  }

  render() {
    const userCanComment = this.props.narrative.user_can_comment || this.props.narrative.user_can_save
    const tabCommentHistory =
      this.props.narrative.comment_history &&
      this.props.narrative.comment_history.length > 1 &&
      this.props.narrative.comment_history.slice(0, -1).filter(comment => comment[this.props.currentTab + '_comment'])
    const displayHistory = tabCommentHistory && tabCommentHistory.length > 0
    return (
      <React.Fragment>
        {this.state.displayOldComments &&
          displayHistory &&
          tabCommentHistory.map((comment, i) => (
            <Comment
              history={this.props.history}
              key={comment.id}
              id={comment.id}
              revision_number={comment.revision_number}
              email={comment.last_edited_by_email}
              name={comment.last_edited_by}
              date={comment.updated_display}
              comment={comment[this.props.currentTab + '_comment']}
            />
          ))}
        {this.state.displayOldComments && displayHistory && (
          <a className={'Comments PrevLink'} onClick={() => this.setState({ displayOldComments: false })}>
            - Hide previous comment{this.props.narrative.comment_history.length > 2 && 's'}
          </a>
        )}
        {!this.state.displayOldComments && displayHistory && (
          <a className={'Comments PrevLink'} onClick={() => this.setState({ displayOldComments: true })}>
            + Show previous comment{this.props.narrative.comment_history.length > 2 && 's'}
          </a>
        )}
        {this.props.narrative.comment_history && this.props.narrative.comment_history.length > 0 && (
          <Comment
            revision_number={this.props.narrative.comment_history.slice(-1)[0].revision_number}
            email={this.props.narrative.comment_history.slice(-1)[0].last_edited_by_email}
            name={this.props.narrative.comment_history.slice(-1)[0].last_edited_by}
            date={this.props.narrative.comment_history.slice(-1)[0].updated_display}
            comment={this.props.narrative.comment_history.slice(-1)[0][`${this.props.currentTab}_comment`]}
          />
        )}

        <textarea
          className='Comments'
          value={this.props.narrative[this.props.currentTab + '_comment']}
          onChange={this.onCommentChange}
          disabled={!userCanComment}
          placeholder={userCanComment ? 'Enter comment' : 'No comment entered.'}
          ref={this.textAreaRef}
          data-testid='comment-textarea'
        />
      </React.Fragment>
    )
  }
}

Comments.propTypes = {
  currentNarrative: PropTypes.object,
  fieldName: PropTypes.string,
  onChange: PropTypes.func,
}

const mapStateToProps = state => ({
  narrative: state.narrative.narrative,
  currentTab: state.appSettings.currentTab,
})

const mapDispatchToProps = { setNarrative, setModal }

Comments = connect(
  mapStateToProps,
  mapDispatchToProps
)(Comments)

export default Comments
